<script setup>
import { computed, nextTick, ref, watch } from "vue";
import Spot from "@components/Spot/Spot.vue";
import StepCard from "./components/StepCard/StepCard.vue";

import steps from "./steps";

const props = defineProps({
  title: { type: String, default: "How it works" },
  description: { type: String, default: "" },
  light: { type: Boolean, default: false },
  customSteps: { type: Array, default: () => [] },
  pink: { type: Boolean, default: false },
});

const slider = ref(null);

watch(
  () => props.customSteps,
  () => {
    nextTick(() => slider.value?.refresh());
  }
);

const stepsList = computed(() => {
  return props.customSteps.length ? props.customSteps : steps;
});
</script>

<template>
  <div class="how-it-works" :class="{ light }">
    <div class="header">
      <span class="title r-h4-to-h2">{{ title }}</span>
      <span v-if="description" class="description r-body-small-to-regular">
        {{ description }}
      </span>
      <Spot
        width="222"
        height="208"
        top="0"
        right="24"
        blur="93"
        opacity="1"
        :color="pink ? 'magenta' : 'blue'"
        mobile
      />

      <Spot
        top="0"
        left="0"
        rotate="180"
        color="magenta"
        opacity="0.6"
        mirror
        desktop
      />
    </div>

    <div class="slider-wrapper hidden-mobile">
      <StepCard
        v-for="(step, index) in stepsList"
        :key="step.title"
        :number="index + 1"
        :title="step.title"
        :description="step.description"
        :image="step.image"
        :alt="step.alt"
        :light="light"
      />
    </div>

    <div class="mobile-slider-wrapper hidden-tablet hidden-desktop">
      <div class="mobile-slider">
        <StepCard
          v-for="(step, index) in stepsList"
          :key="step.title"
          :number="index + 1"
          :title="step.title"
          :description="step.description"
          :image="step.image"
          :alt="step.alt"
          :light="light"
        />

        <div class="spacer"></div>
      </div>
    </div>
  </div>
</template>

<style scoped src="./style.scss" lang="scss" />
